export default {
    props: {
        value: {
            required: true
        }
    },
    filters: {
        placeholder(value) {

            if ( typeof value == 'number' ) {
                value  = value.toString();
            }

            if ( typeof value == 'string' && value.trim() != '' ) {
                return value;
            }

            return '-';
        },
        cents(value) {

            if ( !isNaN(value) ) {
                let amount = value / 100;
                let decimalCount = 2;
            	let decimal = ",";
            	let thousands = ".";

            	decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                let j = (i.length > 3) ? i.length % 3 : 0;

                return "€" + negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
            }

            return value;
        }
    }
}
